<template>
  <div class="main" :class="{error: errorMsg}">
    <slot></slot>
    <div class="page-error" v-show="errorMsg">
      <img src="https://img.thebeastshop.com/images/wap/page-error/page-error.png" alt="">
      <p>{{ errorMsg }}</p>
      <div class="reload" @click="reload">重新加载</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'main',
  props:{
    loading: {
      type: Boolean,
      default: true
    },
    errorMsg: {
      type: String,
      default: ''
    }
  },
  created(){
    this.loading && this.$showLoading()
  },
  methods: {
    reload(){
      window.location.reload()
    }
  }
}
</script>

<style lang="stylus">
  @import '../../common/styl/global'
  .main
    box-sizing border-box
    z-index 10
    &.error
      position relative
  .page-error
    position absolute
    top 0
    bottom 0
    background #FFFFFF
    width 100%
    z-index 99999
    padding-top rem(132)
    color #838383
    img
      width rem(114)
      height rem(111)
      margin-left rem(149)
    p
      padding rem(25) rem(50) rem(22)
      text-align center
      font-size rem(14)
    .reload
      height rem(36)
      line-height rem(36)
      text-align center
      border rem(1) solid #838383
      border-radius rem(2)
      width rem(88)
      margin 0 auto
      
</style>



// WEBPACK FOOTER //
// index.vue?00000c3d